import React from 'react';
import { OnCallAlertStatusType } from '../../utils/enums';
import { useNavigate } from 'react-router-dom';
import {
  SwitchButtonText,
  UserButton,
  UserColumn,
  UserContainer,
  UserLocation,
  UserStatus,
} from './OnCallAlert.styles';
import { translate } from '../../utils/translate';
import { getNumbersBasedDateTextByLanguage } from '../../utils/date';
import phoneIcon from '../../assets/icons/mobile-phone-crossed.svg';
import type { OnCallAlertUser } from '../../containers/OnCallAlertList/onCallAlertSlice/types';

type OnCallAlertUserItemProps = {
  user: OnCallAlertUser;
  selectedGroup: Icon;
  groupId: number;
  onCallAlertId: number;
};

type Icon = {
  id: OnCallAlertStatusType;
  text: string;
  color: string;
};

const OnCallAlertUserItem = (props: OnCallAlertUserItemProps) => {
  const { user, selectedGroup, groupId, onCallAlertId } = props;
  const { userId, userName, responseTime, hasPhoneNumber } = user;
  const navigation = useNavigate();

  const handleMemberSelected = () => {
    return navigation(`/oncall/${onCallAlertId}/memberSettings/${groupId}/${userId}`);
  };
  return (
    <UserContainer onClick={() => handleMemberSelected()} id={`oncallAlertUser-${userId}`}>
      <UserColumn role="userInfoContainer">
        {selectedGroup.id !== OnCallAlertStatusType.NoStatus && (
          <SwitchButtonText role="statusText" color={selectedGroup.color}>
            {translate(selectedGroup.text)}
          </SwitchButtonText>
        )}
        <UserButton role="userName">{userName}</UserButton>
      </UserColumn>
      <UserColumn role="statusContainer">
        <UserStatus paddingRight role="statusText">
          {selectedGroup.id === OnCallAlertStatusType.NoStatus && translate(selectedGroup.text)}
          {selectedGroup.id !== OnCallAlertStatusType.NoStatus &&
            getNumbersBasedDateTextByLanguage({
              dateText: responseTime,
              showOnlyTimeIfToday: true,
            })}
        </UserStatus>
        {!hasPhoneNumber && <UserLocation role="locationIcon" src={phoneIcon} />}
      </UserColumn>
    </UserContainer>
  );
};

export default OnCallAlertUserItem;
